import clsx from "clsx";

import { SubmissionStatusType } from "@interfaces/index";
import { LockSvg, LockOpenSvg } from "@components/index";

export const SubmissionStatus = ({
  status,
  size = "medium",
}: {
  status: {
    label: string;
    value: SubmissionStatusType;
  };
  size?: "medium" | "small";
}) => (
  <div
    className={clsx(
      "flex w-fit items-center gap-x-1 rounded-2xl px-2.5 py-1 *:shrink-0",
      size === "medium" && "text-button *:size-[18px]",
      size === "small" && "text-100 *:size-[12px]",
      status.value === "open" && "bg-primary-108 text-primary-300",
      status.value === "reopened" && "bg-red-8 text-red-100",
      status.value === "waiting_for_review" && "bg-black-4 text-black-54",
      status.value === "in_review" && "bg-brown-8 text-brown-100",
      status.value === "complete" && "bg-green-8 text-green-100",
      status.value === "sent_to_hmrc" && "bg-green-8 text-green-100",
    )}
  >
    {["open", "reopened"].includes(status.value) && <LockOpenSvg />}
    {["waiting_for_review", "in_review", "complete", "sent_to_hmrc"].includes(
      status.value,
    ) && <LockSvg />}
    {status.label}
  </div>
);
